import classNames from 'classnames';
import React from 'react';

import { Dialog as UI5Dialog, DialogPropTypes } from '@ui5/webcomponents-react';

import styles from './Dialog.module.css';
import { Size } from '../../types';

type DialogSize = Extract<Size, 'S' | 'M' | 'L'>;

type PropsWithSize = PropsBase & {
  size?: DialogSize;
  stretch?: false | never;
};

type PropsWithStretch = PropsBase & {
  size?: never;
  stretch?: boolean;
};

type PropsBase = Omit<DialogPropTypes, 'stretch'> & {
  customHeight?: string; // Add customHeight prop
  customWidth?: string; // Add customWidth prop
  footerTopBorder?: boolean;
  headerBottomBorder?: boolean;
  state?: DialogPropTypes['state']; // Add state prop for semantic states
};

type Props = PropsWithSize | PropsWithStretch;

export function Dialog({
  size = 'M',
  headerBottomBorder = true,
  footerTopBorder = true,
  customWidth,
  customHeight,
  state, // Add state prop
  className,
  ...ui5Props
}: Props) {
  const { stretch } = ui5Props;

  const dialogStyles = {
    width: customWidth,
    height: customHeight,
    ...ui5Props.style,
  };

  return (
    <UI5Dialog
      {...ui5Props}
      className={classNames(
        styles.dialog,
        { [styles['header-border-bottom-line']]: !headerBottomBorder },
        { [styles['footer-border-top-line']]: !footerTopBorder },
        ...(stretch ? [] : [styles.constrained, styles[`size-${size?.toLowerCase()}`]]),
        className,
      )}
      state={state} // Pass state prop to UI5Dialog
      style={dialogStyles} // Apply custom styles
    >
      {ui5Props.children}
    </UI5Dialog>
  );
}
